import { cn } from "@/lib/utils";

const Section = ({
  id,
  children,
  className,
  backgroundImage,
  overlay = false,
  ...props
}) => (
  <section
    id={id}
    className={cn("relative w-full", className)}
    style={
      backgroundImage
        ? {
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }
        : undefined
    }
    {...props}
  >
    {overlay && <div className="absolute inset-0 bg-black/45" aria-hidden="true" />}
    <div className={cn("relative", overlay && "z-10")}>{children}</div>
  </section>
);

export default Section;
